<!-- eslint-disable -->
<template>
  <div :class="P_customClass">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <img :src="P_imageSrc" :style="C_imageStyle" v-show="C_isVisible">
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: ["P_imageSrc", 'P_customCss'],
  data () {
    return {}
  },
  mixins: [bi10GridComponent],
  computed: {
    C_imageStyle () {
      return {
        height: '100%',
        width: '100%',
        marginTop: '5px',
        marginLeft: '5px'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Grid/GImage.vue